export default __webpack_public_path__ + "static/apartment-therapy-e011b835b985260b1bd7da77d0fd2572.png";